var exports = {
  "kL": "xcc377c0b--8caa28--container",
  "wm": "xcc377c0b--8caa28--logo",
  "nf": "xcc377c0b--8caa28--link",
};

module.exports = exports;
